import React from 'react';
import { useShadowMode } from '../contexts/ShadowModeContext';
import { useNavigate } from 'react-router-dom';

const ShadowBanner = () => {
  const { shadowUid, shadowUserData, isShadowActive, deactivateShadow, loadingShadow } = useShadowMode();
  const navigate = useNavigate();

  if (!isShadowActive) return null;

  const displayName = shadowUserData?.displayName || shadowUid?.substring(0, 10);
  const email = shadowUserData?.email || '';

  const handleExit = () => {
    deactivateShadow();
    navigate('/dashboard/admin');
  };

  const handleGoAdmin = () => {
    navigate('/dashboard/admin');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 2147483647,
      background: 'linear-gradient(135deg, #0a1a2a 0%, #162a3d 50%, #1a2a3a 100%)',
      borderBottom: '2px solid #e94560',
      padding: '8px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      boxShadow: '0 4px 20px rgba(233, 69, 96, 0.3)',
      fontFamily: "'Inter', sans-serif",
      flexWrap: 'wrap',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{
          background: '#e94560',
          color: 'white',
          padding: '2px 10px',
          borderRadius: '4px',
          fontSize: '0.7rem',
          fontWeight: 'bold',
          letterSpacing: '1px',
          animation: 'shadowPulse 2s infinite',
        }}>
          SHADOW
        </span>
        <span style={{ color: '#e94560', fontSize: '1.1rem' }}>🕵️</span>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ color: '#f1f5f9', fontSize: '0.85rem', fontWeight: 'bold' }}>
            Visualizando como: {displayName}
          </span>
          {email && (
            <span style={{ color: '#94a3b8', fontSize: '0.72rem' }}>
              {email}
            </span>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <span style={{ color: '#64748b', fontSize: '0.72rem' }}>
          {loadingShadow ? 'Cargando...' : 'Solo lectura — las operaciones están deshabilitadas'}
        </span>
        <button
          onClick={handleGoAdmin}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            color: '#cbd5e1',
            padding: '4px 12px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '0.75rem',
            fontWeight: 'bold',
          }}
        >
          ⚙️ Admin
        </button>
        <button
          onClick={handleExit}
          style={{
            background: '#e94560',
            border: 'none',
            color: 'white',
            padding: '4px 14px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '0.75rem',
            fontWeight: 'bold',
          }}
        >
          ✕ Salir
        </button>
      </div>

      <style>{`
        @keyframes shadowPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
        body { margin-top: ${isShadowActive ? '52px' : '0'} !important; }
      `}</style>
    </div>
  );
};

export default ShadowBanner;
